export const authClient = {
    usa: {
        baseUrl: "https://app.clio.com/oauth",
        prod: {
            clientId: "VAZgP1yEtjX0gQ0qX5aLyc01wmiYvM9qeAWSZHtI",
        },
        staging: {
            clientId: "VAZgP1yEtjX0gQ0qX5aLyc01wmiYvM9qeAWSZHtI",
        },
        test: {
            clientId: "EfHxBsbgQFFSng32g9Pag9XuHjNnEepPu7atWG6t",
        },
        local: {
            clientId: "EfHxBsbgQFFSng32g9Pag9XuHjNnEepPu7atWG6t",
        }
    },
    canada: {
        baseUrl: "https://ca.app.clio.com/oauth",
        prod: {
            clientId: "gXB1ajjFhn2VMlQZKXdWJWEmZFKlzW49OCxXm3Lx",
        },
        staging: {
            clientId: "SwJe8ESr0iNMRmL6yovbJbZLTAWjqRdZdb2p9sY0",
        },
        test: {
            clientId: "DXJ4uPNI2KNzP9Qc5ktLVRBHMa4F6BfbNYGY2luK",
        },
        local: {
            clientId: "DXJ4uPNI2KNzP9Qc5ktLVRBHMa4F6BfbNYGY2luK",
        }
    },
    europe: {
        baseUrl: "https://eu.app.clio.com/oauth",
        prod: {
            clientId: "1L9tNNmdsHMknvjyGWEbFDI32rObNP6tCZ8TTZWL",
        },
        staging: {
            clientId: "Q2A3b5R4ZA2kOErgflpCO5VGf9hI16LRVJx1Tf4x",
        },
        test: {
            clientId: "1FPy07jUQnsoq00fq0lgEZEZ97mE30HESVDZKxIR",
        },
        local: {
            clientId: "1FPy07jUQnsoq00fq0lgEZEZ97mE30HESVDZKxIR",
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/constants/authClient.const.js